import axios from 'axios';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Get Cognito configuration from environment variables
const getCognitoConfig = () => {
  const region = import.meta.env.VITE_COGNITO_REGION || 'eu-west-2';
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;

  if (!userPoolId || !clientId) {
    return null;
  }

  return {
    region,
    userPoolId,
    clientId,
  };
};

const cognitoConfig = getCognitoConfig();
const userPool = cognitoConfig
  ? new CognitoUserPool({
      UserPoolId: cognitoConfig.userPoolId,
      ClientId: cognitoConfig.clientId,
    })
  : null;

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
});

// Add auth token interceptor
apiClient.interceptors.request.use(
  async (config) => {
    // Try to get access token from Cognito session
    if (userPool) {
      try {
        const currentUser = userPool.getCurrentUser();
        if (currentUser) {
          const session = await new Promise<any>((resolve, reject) => {
            currentUser.getSession((err: Error | null, session: any) => {
              if (err) reject(err);
              else resolve(session);
            });
          });

          if (session && session.isValid()) {
            // API Gateway Cognito authorizer requires ID token, not access token
            const idToken = session.getIdToken().getJwtToken();
            config.headers.Authorization = `Bearer ${idToken}`;
          }
        }
      } catch (error) {
        // If token retrieval fails, continue without auth header
        // The backend will handle this appropriately
        console.warn('Failed to get auth token:', error);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

